import { combineEpics, type Epic } from 'redux-observable';
import { filter, map } from 'rxjs';
import { request } from '@/core';
import { fetchEventMatchScoreRequest } from '@/api/events';
import { fetchEventMatchScore, setCurrentMatchScore } from '../actions';

const fetchEventMatchScoreEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEventMatchScore.match),
    request(
      ({ payload }) => fetchEventMatchScoreRequest(payload),
      fetchEventMatchScore,
    ),
  );

const fetchEventMatchScoreSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEventMatchScore.succeeded.match),
    map(({ payload: { data } }) => setCurrentMatchScore(data)),
  );

export default combineEpics(
  fetchEventMatchScoreEpic,
  fetchEventMatchScoreSucceededEpic,
);
